import FieldView from "../../field/field-view";
import GroupView from "../view/group-view";
import TreeViewForm from "../view/tree-view-form";
/** 
* Lấy danh sách component
* @param {object[]} fields - danh sách field
* @param {object} viewData - dữ liệu từ get field view.
* @param {string} resModel - tên model chính.
* @param {object} onchangeData - form values.
* @param {function} handleOnchange - hàm xử lí khi field xảy ra sự kiện onchange or onblur.
* @param {boolean} isInTab - xác định component có nằm trong tab không để hiển thị label đúng.
* @return {component[]} - Danh sách các component hiển thị UI
*/
const useHandleField = ({ fields, viewData, resModel, onchangeData = {}, handleOnchange, setOnchangeData, isInTab = false }) => {

    const fieldList = (fields ??= [])?.map((field, index) => {
        if (field?.type_co === "field") {
            const fieldDataRoot = viewData?.models?.[resModel]?.[field?.name] || {};
            const mergedField = { ...fieldDataRoot, onchangeData: onchangeData, setOnchangeData: setOnchangeData, ...field };
            return <FieldView handleOnchange={handleOnchange} key={index} {...mergedField} isForm={true} />
        }
        else if (field?.type_co === "group") {
            const mergeProps = { viewData: viewData, resModel: resModel, onchangeData: onchangeData, setOnchangeData: setOnchangeData, ...field }
            return (<GroupView handleOnchange={handleOnchange} key={index} {...mergeProps} />)
        }
        else if (field?.type_co === "tree") {
            return <div className="col-span-2 my-4">
                {!isInTab ? <span className='text-sm font-medium text-dark'>{field?.string}</span> : <></>}
                <TreeViewForm handleOnchange={handleOnchange} onchangeData={onchangeData} field={{ ...field, modelTab: viewData?.models?.[resModel]?.[field?.name] }} viewData={viewData} resModel={resModel} key={index} setOnchangeData={setOnchangeData} />
            </div>
        }
        else {
            return <></>
        }
    });

    return {
        fieldList,
    }
};

export default useHandleField